const ProducsData = [
  {
    installments: "em até 3x no cartão",
    type: "Pré treino Psicho Killer ",
    productBrand: "Demons-Lab",
    description: "294g",
    priceWithoutDiscount: "100.00",
    quantity: "6",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_psycho_killer_294g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Hipercalórico",
    productBrand: "Diabo-Verde",
    description: "2,5Kg",
    priceWithoutDiscount: "90.00",
    quantity: "6",
    imageSrc: require("../../assets/ImgProducts/Hypercaloric/diabo_verde_massivemass_hypercaloric_2_5kg-refil.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Whey Protein",
    productBrand: "Integral medica",
    description: "900g Refil",
    priceWithoutDiscount: "100.00",
    quantity: "6",
    imageSrc: require("../../assets/ImgProducts/Whey/whey_integralmedica_907g-refil.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Creatina",
    productBrand: "Integral medica",
    description: "150g",
    priceWithoutDiscount: "90.00$",
    quantity: "6",
    imageSrc: require("../../assets/ImgProducts/Creatine/creatine_integralmedica_150g.png"),
  },
];

export default ProducsData;
